import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReloginRoutingModule } from "./relogin-routing.module";
import { ReloginComponent } from "./relogin.component";
import {
    MatIconModule,
    MatDividerModule,
    MatFormFieldModule,
    MatProgressBarModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatButtonModule,
    MatInputModule
} from "@angular/material";
import {
    ReactiveFormsModule,
    FormsModule
} from "@angular/forms";
import { RecaptchaModule } from "angular-google-recaptcha";
import { RecuperarDialog } from "../../../forms/usuarios/recuperar-dialog/recuperar-dialog.component";
import {
    DeviceDetectorService,
    DeviceDetectorModule
} from "ngx-device-detector";
import { ClienteService } from "../../../providers/cliente.service";

@NgModule({
    imports: [
        CommonModule,
        ReloginRoutingModule,
        MatIconModule,
        MatDividerModule,
        ReactiveFormsModule,
        FormsModule,
        RecaptchaModule.forRoot({
            siteKey: '6Ldo0EcUAAAAAObjlVGcceMIKhDRVhHWr4oNANi_',
        }),
        MatProgressBarModule,
        MatCardModule,
        MatProgressSpinnerModule,
        DeviceDetectorModule.forRoot(),
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
    ],
    declarations: [
        ReloginComponent,
    ],
    providers: [
        DeviceDetectorService,
        ClienteService
    ],
    entryComponents: [
    ]
})
export class ReloginModule { }